exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sink-empty-add{margin-top:6px}.sink-add{margin-left:0px !important;position:relative;height:25px}.sink-add-drop-down{height:25px}.sink-add-padding{padding-left:4px}.sink-add-btn-wrapper{margin-bottom:0px;display:inline-flex;align-items:flex-end}\n", ""]);

// exports
